export enum CardPaymentStatus {
  PENDING = "PENDING",
  DUPLICATE = "DUPLICATE",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
  THREE_DS_CHALLENGED = "3DSCHALLENGED",
}

export enum PaymentNotificationStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
  SKIPPED = "SKIPPED",
}

export enum JuniferPaymentStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
  PENDING_STATUS_FROM_JUNIFER = "PENDING_STATUS_FROM_JUNIFER",
}

export interface ICardPaymentDetails {
  status: CardPaymentStatus
  notificationStatus: PaymentNotificationStatus
  juniferPaymentStatus: JuniferPaymentStatus
  amountInPence: number
  reference: string
  errorCode?: string
  errorMessage?: string
  notificationError?: string
}
